import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { ClubsStore } from '../../../clubs/clubs.store';
import { ClubActivityService } from '../../../clubs/services/club-activity.service';
import { AuthenticatedUser } from '../../../models/identity/authenticated-user.model';
import { AccountsService } from '../../../services/identity/accounts.service';
import { WelcomeService } from '../../../services/welcome/welcome-service';
import { Club } from './../../../models/clubs/club.model';

@Component({
    selector: 'app-home-page',
    styleUrls: ['./home-page.component.scss'],
    templateUrl: './home-page.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class HomePageComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();

    public welcomePercentage = 0;
    public userClubs: Club[];
    public userClubsId: string[] = [];

    public isManagingCommunity = false;

    public isAlreadyInWudoClub = false;
    public currentUser: AuthenticatedUser;
    public countClubNotifications = 0;

    public isRegistrationSidebarVisible = false;
    public registrationCount = 0;
    constructor(
        private readonly accountsService: AccountsService,
        private readonly welcomeService: WelcomeService,
        readonly clubActivityService: ClubActivityService,
        readonly clubsStore: ClubsStore,
    ) {}

    ngOnInit() {
        this.currentUser = this.accountsService.currentUser;

        this.welcomeService.steps$.pipe(takeUntil(this.destroy$)).subscribe(() => {
            this.welcomePercentage = this.welcomeService.getCompletedStepsPercentage();
        });

        this.isManagingCommunity = this.accountsService.getCommunitiesManagedByUser().length > 0;
        this.isAlreadyInWudoClub = this.accountsService.currentUser.communities.some(
            (community) => community.id === environment.communitiesId.wudoCommunityId,
        );
    }

    ngOnDestroy() {
        this.destroy$.next();
        this.destroy$.complete();
    }

    redirectToJoinWudoClubPage() {
        window.location.href = environment.wudoClubJoinLink;
    }

    public onRegistrationsChanged(newCount: number): void {
        this.registrationCount = newCount;
    }
}
